import { type ModalProps } from "@shapr3d/frontend-lib";

import type { SeatBasedTeamSubscription } from "../../../hooks/useTeamsTypes";
import useTranslation from "../../../hooks/useTranslation";
import { SubscriptionTier } from "../../../types";
import { SubscriptionUpgradeModal } from "../SubscriptionUpgradeModal/SubscriptionUpgradeModal";

export const UpgradeToStudioModal: React.FC<
  Pick<ModalProps, "open" | "onClose"> & {
    subscription: SeatBasedTeamSubscription;
    teamID: string | undefined;
  }
> = ({ subscription, teamID, onClose, open }) => {
  const { t, m } = useTranslation();

  return (
    <SubscriptionUpgradeModal
      subscription={subscription}
      teamID={teamID}
      onClose={onClose}
      open={open}
      tier={SubscriptionTier.Studio}
      // TODO: multi-seat studio upgrade not yet supported — hiding selector, always sends null
      hideSeatSelector
      toApiSeatCount={(value) => (value === 1 ? null : value - 1)}
      copy={{
        title: t(m.UpgradeToStudioModal.Title),
        submitButton: t(m.UpgradeToStudioModal.ConfirmButton),
        toastSuccess: t(m.UpgradeToStudioModal.ToastSuccess),
        errorTitle: t(m.UpgradeToStudioModal.ErrorTitle),
        errorText: t(m.UpgradeToStudioModal.ErrorText),
        paymentErrorTitle: t(m.UpgradeToStudioModal.PaymentErrorTitle),
        paymentErrorText: t(m.UpgradeToStudioModal.PaymentErrorText),
        paymentCTAText: t(m.UpgradeToStudioModal.UpdateAndUpgradeCTA),
        learnMore: t(m.UpgradeToStudioModal.LearnMoreAboutTeams),
        tertiaryText: ({
          currencySymbol,
          proratedTotalAmount,
          renewalCurrencyCode,
          proratedCurrencyCode,
        }) =>
          t(m.UpgradeToStudioModal.TertiaryText, {
            currencySymbol,
            amount: proratedTotalAmount,
            allPricesInUSD:
              renewalCurrencyCode === "USD"
                ? t(m.Checkout.Summary.AllPricesIn, { currency: proratedCurrencyCode })
                : "",
          }),
      }}
    />
  );
};
